import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "minipopup-box" }
const _hoisted_2 = { class: "product" }
const _hoisted_3 = { class: "product-media" }
const _hoisted_4 = ["src", "onError"]
const _hoisted_5 = { class: "product-detail" }
const _hoisted_6 = { class: "product-action" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("View Cart")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Checkout")
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createBlock(_component_notifications, {
    duration: 2000,
    width: 300,
    max: 4,
    "animation-name": "fade-left",
    position: "bottom right",
    closeOnClick: ""
  }, {
    body: _withCtx((props) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("figure", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: '/product/' + props?.item?.data?.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.getImage(props?.item?.data?.images),
                  alt: "product",
                  onError: (e) => e.target.src = require('@/static/images/generic.jpeg')
                }, null, 40, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: '/product/default/' + props?.item?.data?.slug,
              class: "product-name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props?.item?.data?.product?.manufacturer.name) + " " + _toDisplayString(props?.item?.data?.product?.mpn), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("p", null, _toDisplayString(props?.item?.text), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.CART },
            class: "btn viewcart"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: { name: _ctx.CHECKOUT },
            class: "btn btn-dark checkout"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("button", {
          class: "mfp-close",
          onClick: props.close
        }, null, 8, _hoisted_9)
      ])
    ]),
    _: 1
  }))
}